import React from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { ContactForm } from "./ContactForm.tsx";

// Styled Components
const StyledDialogAppBar = styled(AppBar)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.primary.main,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}));

const StyledDialogTitle = styled(Typography)(({ theme }) => ({
  flex: 1,
}));

const StyledDialogContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

interface BookingDialogProps {
  open: boolean;
  onClose: () => void;
}

export const BookingDialog: React.FC<BookingDialogProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      aria-labelledby="contact-dialog-title"
      aria-describedby="contact-dialog-description"
    >
      <StyledDialogAppBar>
        <Toolbar>
          <StyledDialogTitle 
            variant="h6"
            id="contact-dialog-title"
          >
            Informatie & opvang
          </StyledDialogTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="Sluit reserveringsformulier"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </StyledDialogAppBar>
      <StyledDialogContent id="contact-dialog-description">
        <ContactForm />
      </StyledDialogContent>
    </Dialog>
  );
};
